import { mixins } from 'vue-class-component';
import { Component } from 'vue-property-decorator';
import BaseMixin from './base-mixin';
import DictMixin from './dict-mixin';
@Component
export default class BaseFormMixin extends mixins(DictMixin, BaseMixin) {
  current = 0;
  /**
   * 同类型切换时不需要缓存，其他页面切换TAB页缓存数据
   */
  cache: boolean = true;
  isNeedCache(from: any, to: any): boolean {
    let fromPath = from.path;
    let toPath = to.path;
    if (/\/(edit|add)/.test(toPath)) {
      let fromBasePath: string = fromPath
        .split('/')
        .filter((v: string, index: number) => index < 3)
        .join('/');
      let toBasePath: string = toPath
        .split('/')
        .filter((v: string, index: number) => index < 3)
        .join('/');
      return fromBasePath !== toBasePath;
    } else {
      return true;
    }
  }

  next() {
    this.current++;
  }

  preview() {
    this.current--;
  }
}
